(() => {
function mount(){
document.querySelectorAll('.arm-p-gallery').forEach(gallery=>{
if(gallery.dataset.photoNavReady)return;
const main=gallery.querySelector('.arm-p-photo'),thumbs=[...gallery.querySelectorAll('.arm-colour-thumb[data-full]')];
if(!main||!thumbs.length)return;
gallery.dataset.photoNavReady='true';
const key=value=>{try{return new URL(value,location.href).pathname}catch{return value}};
const nav=document.createElement('div');nav.className='arm-photo-nav';
const previous=document.createElement('button'),next=document.createElement('button'),counter=document.createElement('span');
previous.type=next.type='button';previous.textContent='‹';next.textContent='›';
previous.setAttribute('aria-label',gallery.dataset.photoPrevious);next.setAttribute('aria-label',gallery.dataset.photoNext);
counter.setAttribute('role','status');counter.setAttribute('aria-live','polite');counter.setAttribute('aria-atomic','true');
nav.append(previous,counter,next);main.after(nav);
const visible=()=>thumbs.filter(button=>!button.hidden);
function sync(){
const items=visible(),index=items.findIndex(button=>key(button.dataset.full)===key(main.src));
nav.hidden=items.length<2||main.hidden;
counter.textContent=(index<0?1:index+1)+' / '+items.length;
thumbs.forEach(button=>button.setAttribute('aria-pressed',String(key(button.dataset.full)===key(main.src))));
}
function move(delta){
const items=visible();if(items.length<2)return;
const index=items.findIndex(button=>key(button.dataset.full)===key(main.src));
items[((index<0?0:index)+delta+items.length)%items.length].click();sync();
}
thumbs.filter(button=>button.hasAttribute('data-arm-dpa-thumb')).forEach(button=>button.addEventListener('click',()=>{
main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=button.dataset.full;main.alt=button.dataset.alt||'';sync();
}));
previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
main.tabIndex=0;main.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1)}});
let start;
main.addEventListener('touchstart',event=>{start=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null},{passive:true});
main.addEventListener('touchend',event=>{
if(!start||!event.changedTouches.length)return;
const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;
if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)move(dx<0?1:-1);
},{passive:true});
main.addEventListener('touchcancel',()=>{start=null},{passive:true});
const observer=new MutationObserver(sync);observer.observe(main,{attributes:true,attributeFilter:['src','hidden']});thumbs.forEach(button=>observer.observe(button,{attributes:true,attributeFilter:['hidden']}));sync();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
document.addEventListener('shopify:section:load',mount);
})();